// Our main CSS
import '../css/app.css'

const initNonCritical = async () => {

  /*
   *  Toggle link active states depending on the current hash
   */

  const updateHashActiveLinks = () => {
    document.querySelectorAll<HTMLAnchorElement>('a[href*="#"][data-active]').forEach((a) => {
      const url = new URL(a.href, window.location.href)
      const pathMatch = url.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '')
      const hashMatch = url.hash === window.location.hash
      a.dataset.active = pathMatch && hashMatch ? '1' : '0'
    })
  }

  updateHashActiveLinks()
  window.addEventListener('hashchange', updateHashActiveLinks)

  /*
   *  Scroll to the corresponding block if the page is loaded with a hashtag
   *  or when the hash changes while already on the page
   */

  const scrollToHash = (hash: string) => {
    if (!hash) {
      return
    }

    const id = hash.substring(1)
    const element = document.getElementById('section_' + id)

    if (element) {
      const headerOffset = document.querySelector<HTMLElement>('header > nav')?.offsetHeight || 0
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset
      const offsetPosition = elementPosition - headerOffset - 100

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      })
    }
  }

  scrollToHash(window.location.hash)
  window.addEventListener('hashchange', () => scrollToHash(window.location.hash))

  /*
   *  Toggle header visibility depending on scroll direction
   */

  const header = document.querySelector<HTMLElement>('header > nav')

  if (header) {
    import('./modules/header-visibility').then(({ default: toggleHeaderVisibility }) => {
      toggleHeaderVisibility(header)
    })
  }

  /*
   *  Toggle the visibility of accordion buttons depending on
   *. if the accordion has overflow.
   */

  const accordions = document.querySelectorAll<HTMLElement>('.accordion')

  if (accordions?.length) {
    import('./modules/accordion-overflow').then(({ default: checkAccordionOverflow }) => {
      checkAccordionOverflow(accordions)
    })
  }

  /*
   *  Animate fancy numbers.
   */

  const numbers = document.querySelectorAll<HTMLElement>('.number')

  if (numbers?.length) {
    numbers.forEach(async (number) => {
      import('./modules/fancy-numbers').then(({ default: animateFancyNumbers }) => {
        animateFancyNumbers(number)
      })
    })
  }

  /*
   *  Lazy load video handling
   */

  const autoplaying_videos = document.querySelectorAll<HTMLVideoElement>('video[playsinline]');

  if (autoplaying_videos?.length) {
    import('./modules/inline-videos').then(({ default: handleVideos }) => {
      handleVideos(autoplaying_videos)
    })
  }

  /*
   *  Intersecting elements helper
   */

  const check_intersecting = document.querySelectorAll(
    '[data-check-intersecting]'
  ) as NodeListOf<HTMLElement>

  if (check_intersecting?.length) {
    import('./modules/check-intersection').then(({ default: init }) => {
      init(check_intersecting)
    })
  }

  /*
   *  Custom cookie consent banner handling
   */

  const gtag = document.querySelector<HTMLDivElement>('#gtag')?.dataset.gtmId
  const addGtag = () => {
    if (!gtag) {
      return
    }
    const w = window as any
    w.dataLayer = w.dataLayer || []
    w.gtag = w.gtag || function() { w.dataLayer.push(arguments) }
    w.gtag('js', new Date())
    w.gtag('config', gtag)
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gtag}`
    document.head.appendChild(script)
  }

  const cookieBanner = document.querySelector<HTMLElement>('[data-cookie-consent]')
  if (cookieBanner) {
    if (localStorage.getItem('cookie-consent') === null) {
      cookieBanner.style.display = ''
      cookieBanner.querySelector<HTMLElement>('[data-cookie-consent-accept]')
        ?.addEventListener('click', () => {
          localStorage.setItem('cookie-consent', 'accepted')
          cookieBanner.remove()
          addGtag()
        })
      cookieBanner.querySelector<HTMLElement>('[data-cookie-consent-reject]')
        ?.addEventListener('click', () => {
          localStorage.setItem('cookie-consent', 'rejected')
          cookieBanner.remove()
        })
    } else if (localStorage.getItem('cookie-consent') === 'accepted') {
      addGtag()
    }
  } else {
    addGtag()
  }
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(() => initNonCritical())
} else {
  // Fallback for browsers that don't support requestIdleCallback
  setTimeout(initNonCritical, 1)
}
